// const analyticsResources = {
//     All: 'Todos',
//     StoreFront: 'Montra de Produto',
//     Filters: 'Filtros',
//     Categories: 'Categorias',
//     ClearFilters: 'Limpar Filtros',
//     ClearAllFilters: 'Limpar todos os filtros',
//     StoreFrontDisplay: 'Vista de Produto',
//     Comparator: 'Comparador',
//     ComparatorBtn: 'Botão Comparar',
//     AddComparator: 'Adicionar ao Comparador',
//     RemoveComparator: 'Remover do Comparador',
//     Product: 'Produto'
// }

export class Analytics {
	static push(
		dataEventReg,
		dataEventStep,
		dataEventTitle,
		dataEventField,
		dataEventLine
	) {
		const dataObj = window.dataLayer;
		if (dataObj) {
			dataObj.push({
				"data-eventreg": dataEventReg,
				"data-eventstep": dataEventStep,
				"data-eventtitle": dataEventTitle,
				"data-eventfield": dataEventField,
				"data-eventline": dataEventLine
			});
		}
	}
}
